import { ChargingStationConstant } from "./chargingStationConstant";

const chargingStationActions = {};

// chargingStationActions.getChargingStations = ({
//   to_date ,
//   from_date ,
//   search_term,
//   limit ,
//   page ,
// }) => ({
//   type: ChargingStationConstant.CHARGING_STATION_SAGA,
//   payload: {
//     to_date: to_date,
//     from_date: from_date,
//     search_term: search_term,
//     limit: limit,
//     page: page
//   }
 



chargingStationActions.getChargingStations = ({
  to_date ,
  sort,
  from_date ,
  search_term,
  limit ,
  page ,
  network,
  
} = {}) => {

  return {
    type: ChargingStationConstant.CHARGING_STATION_SAGA,
    payload: {
      to_date: to_date,
      sort:sort,
      from_date: from_date,
      search_term: search_term,
      limit: limit??100,
      page: page,
      network:network
    }
  };
};


chargingStationActions.postBulkData = (payload) => {
  return {
    type: ChargingStationConstant.POST_CHARGING_STATION_BULK_SAGA,
    payload: payload,
  };
};

chargingStationActions.deleteChargingStation = (id) => {
  return {
    type: ChargingStationConstant.CHARGING_STATION_DELETE_SAGA,
    payload: id,
  };
};

chargingStationActions.ChargingStationDetail = (id) => {
  return {
    type: ChargingStationConstant.CHARGING_STATION_DETAIL_SAGA,
    payload: id,
  };
};

//charging point
chargingStationActions.getChargingPoint = (station_id) => ({
  type: ChargingStationConstant.GET_CHARGING_POINT_SAGA,
  station_id: station_id,
});

chargingStationActions.getChargingConnectorDropdown = (payload) => ({
  type: ChargingStationConstant.GET_CHARGER_CONNECTOR_DROPDOWN_SAGE,
  payload:payload
});

chargingStationActions.getChargingNetworkDropdown = (payload) => (console.log('fefjeife',payload),
{
  type: ChargingStationConstant.CHARGING_STATION_NETWORK_SAGA,
  payload:payload
});

chargingStationActions.deleteChargingConnectorActions = (id) => {
  return {
    type: ChargingStationConstant.DELETE_CHARGING_CONNECTOR_SAGA,
    payload: id,
  };
};

//vendor select

chargingStationActions.getVendorSelectWiseAction = () => ({
  type: ChargingStationConstant.GET_VENDOR_SELECT_WISE_SAGA,
});

chargingStationActions.AddChargingTableEnableDisable = (pay) => {
  return {
    type: ChargingStationConstant.ENABLE_DESABLE_CHARGING_TABLE_SAGA,
    payload: pay,
  };
};
// CSC
chargingStationActions.getChargingStationCount = () => ({
  type: ChargingStationConstant.CHARGING_STATION_COUNT_SAGA,
});

//charging station see all
chargingStationActions.getChargingStationSeeAllRequest = () => ({
  type: ChargingStationConstant.CHARGING_SEEALLRES_SAGA,
});

export { chargingStationActions };
